export const ANALYSIS_PLAN_LIST_APP_STATE_SLICE_KEY = 'analysisPlanList';
export const ANALYSIS_PLAN_LIST_STATE_KEYS = [
    'owner',
    'name',
    'sortColumn',
    'sortDirection',
    'viewRootFolder',
    'includeEmptyFolders',
];
// The system default state excludes sortColumn and sortDirection
export const ANALYSIS_PLAN_LIST_SYSTEM_DEFAULT_STATE = {
    owner: {
        me: true,
        shared_with_me: true,
    },
    name: '',
    viewRootFolder: null,
    includeEmptyFolders: false,
};
